<template>
  <div class="pagination">
    <div class="loader">
      <div class="filled" :style="{ width: `${percent}%` }"></div>
    </div>
    <p v-show="!testCompleted" class="text">Schritt {{ current }} von {{ all }} ({{ percent }}%)</p>
    <p v-show="testCompleted" class="text">Fertig!</p>
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  computed: {
    current() {
      return this.$store.state.activeStep
    },
    all() {
      return this.$store.getters.allSteps
    },
    percent() {
      return 100 / this.$store.getters.allSteps * this.$store.state.activeStep
    },
    testCompleted() {
      return this.$store.state.testCompleted
    },
  },
}
</script>

<style scoped>
.pagination {
  margin: 0 15px;
  text-align: center;
  color: white;
  font-weight: 700;
  font-size: 0.85rem;
}

.loader {
  width: 100%;
  max-width: 470px;
  margin: 20px auto;
  border: 1px solid white;
  border-radius: 3px;
  height: 6px;
  overflow: hidden;
}

.loader .filled {
  background-color: white;
  height: 4px;
  transition: 0.2s;
}
</style>



// WEBPACK FOOTER //
// src/components/Pagination.vue